var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{key:'supportModalChat',ref:"chatDialog",staticClass:"modal--support-chat",attrs:{"title":"Чат поддержки","chatMode":true},on:{"close":function($event){return _vm.$emit('close')}}},[_c('support-chat')],1)}
var staticRenderFns = []

export { render, staticRenderFns }